import React from "react"
import "./Button.css"
import { Link } from "gatsby"
import PropTypes from "prop-types"

const STYLES = [
  "btn--blue",
  "btn--orange",
  "btn--grey",
  "btn--blue--bg",
  "btn--blue--bg--orange--border",
  "btn--grey--bg",
  "btn--transparent",
  "btn--white",
]

const SIZES = ["btn--large", "btn--small"]

export const Button = ({
  id,
  label,
  type,
  handleClick,
  buttonStyle,
  buttonSize,
  font,
  iconLeft,
  iconRight,
  link,
  externalLink,
  isExternal,
}) => {
  const checkButtonStyle = STYLES.includes(buttonStyle)
    ? buttonStyle
    : STYLES[0]
  const checkButtonSize = SIZES.includes(buttonSize) ? buttonSize : SIZES[0]

  if (type === "submit") {
    // Render as a native submit button
    return (
      <button
        id={id}
        className={
          "btn " + checkButtonStyle + " " + checkButtonSize + " " + font
        }
        type="submit" // Ensure it behaves as a submit button
        onClick={handleClick} // Optional: handle additional logic on click
      >
        <div>
          {iconLeft ? <img alt="" src={iconLeft} /> : ""}
          {label}
        </div>
        {iconRight ? <img alt="" src={iconRight} /> : ""}
      </button>
    )
  }

  if (externalLink || isExternal) {
    // Render as an external link
    return (
      <a
        id={id}
        href={externalLink}
        className={
          "btn " + checkButtonStyle + " " + checkButtonSize + " " + font
        }
        onClick={handleClick}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div>
          {iconLeft ? <img alt="" src={iconLeft} /> : ""}
          {label}
        </div>
        {iconRight ? <img alt="" src={iconRight} /> : ""}
      </a>
    )
  }

  // Render as an internal link
  return (
    <Link
      to={link}
      className={"btn " + checkButtonStyle + " " + checkButtonSize + " " + font}
      onClick={handleClick}
    >
      <div>
        {iconLeft ? <img alt="" src={iconLeft} /> : ""}
        {label}
      </div>
      {iconRight ? <img alt="" src={iconRight} /> : ""}
    </Link>
  )
}

Button.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  handleClick: PropTypes.func,
  buttonStyle: PropTypes.string,
  buttonSize: PropTypes.string,
  font: PropTypes.string,
  iconLeft: PropTypes.string,
  iconRight: PropTypes.string,
  link: PropTypes.string,
  externalLink: PropTypes.string,
  isExternal: PropTypes.bool,
}

export default Button
